import { render, staticRenderFns } from "./RegisterStarterForm.vue?vue&type=template&id=735690f4&scoped=true"
import script from "./RegisterStarterForm.vue?vue&type=script&lang=js"
export * from "./RegisterStarterForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterStarterForm.vue?vue&type=style&index=0&id=735690f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735690f4",
  null
  
)

export default component.exports